import TemplateView from '../../../../../TemplateView'
import {contextCheckingStatus, hostingZone} from '../../../constants'
import messageResource from '../../../../../messageResource'
import InputField from '../../../../../components/InputField'
import SimpleTooltip from '../../../../../SimpleTooltip'
import $ from '../../../../../alias/jquery'
import LoadingSpinner from '../../../../../components/LoadingSpinner'

export default class ContextEditor extends TemplateView {
    constructor({
        onContextChanged = () => {},
    } = {}) {
        super()

        this.callbacks = {
            onContextChanged,
        }

        this.state = {
            hostingZone: '',
            hostingZoneChanged: false,
            context: '',
            isContextChanged: false,
            contextInUse: false,
            contextInvalid: false,
            contextCheckingStatus: null,
        }

        this.onAnyStatePropertyChanged(['hostingZone', 'hostingZoneChanged'], () => {
            const path = messageResource.getMessage('licenses.purchase_lightbox.review_context.path', [
                this.state.hostingZone === hostingZone.NORTH_AMERICA ? messageResource.getMessage('licenses.purchase_lightbox.review_context.zone_online')
                                                                     : messageResource.getMessage('licenses.purchase_lightbox.review_context.zone_eu')
            ])
            this.$path.html(path)
            this.$path.toggleClass('hostingZoneChanged', this.state.hostingZoneChanged)
            this.$el.toggleClass('eu', this.state.hostingZone === hostingZone.EUROPE)
            this.$el.toggleClass('online', this.state.hostingZone === hostingZone.NORTH_AMERICA)
        })

        this.onStatePropertyChanged('context', (value) => {
            this.contextInput.setState({value})
        })

        this.onAnyStatePropertyChanged(['hostingZoneChanged', 'isContextChanged', 'contextInUse', 'contextInvalid'], () => {
            const hasError = this.state.contextInUse || this.state.contextInvalid

            const hostingZoneText = messageResource.getMessage(this.state.hostingZone === hostingZone.EUROPE
                                                               ? 'hosting_zone.europe'
                                                               : 'hosting_zone.north_america')
            this.$zoneUpdatedText.text(messageResource.getMessage('licenses.purchase_lightbox.review_context.zone_updated_tip', [hostingZoneText]))
            this.$zoneUpdated.toggle(!hasError && this.state.hostingZoneChanged)
            this.$contextUpdated.toggle(!hasError && !this.state.hostingZoneChanged && this.state.isContextChanged)

            if (hasError) {
                this.$errorMessage.text(messageResource.getMessage(this.state.contextInvalid
                                                                   ? 'licenses.purchase_lightbox.review_context.validation_error'
                                                                   : 'licenses.purchase_lightbox.review_context.address_in_use'))
            }
            this.$errorMessage.toggle(hasError)
            this.$contextInput.toggleClass('hasError', hasError)
        })

        this.onAnyStatePropertyChanged(['contextCheckingStatus', 'contextInUse', 'contextInvalid'], () => {
            this.checkingSpinner.setState({show: this.state.contextCheckingStatus === contextCheckingStatus.IN_PROGRESS})
            this.$tickIcon.toggle(
                this.state.contextCheckingStatus === contextCheckingStatus.COMPLETED && !this.state.contextInUse && !this.state.contextInvalid)
        })
    }

    templateHtml() {
        return '<div class="contextEditor">' +
               '    <div class="url">' +
               '        <div class="path"/>' +
               '        <div class="context">' +
               '            <div class="contextInput"/>' +
               '            <div class="infoIcon"/>' +
               '        </div>' +
               '        <div class="process">' +
               '            <div class="tickIcon"/>' +
               '            <div class="spinnerPlaceholder"/>' +
               '        </div>' +
               '    </div>' +
               '    <div class="errorMessage"/>' +
               '    <div class="tips">' +
               '        <div class="contextUpdated">' +
               '            <div class="arrow"/>' +
               '            <div class="text"><%=contextUpdated%></div>' +
               '        </div>' +
               '        <div class="zoneUpdated">' +
               '            <div class="arrow"/>' +
               '            <div class="text"/>' +
               '        </div>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            contextUpdated: 'licenses.purchase_lightbox.review_context.context_updated_tip',
        }
    }

    afterRender() {
        this.$path = this.find('.url .path')
        this.$contextUpdated = this.find('.contextUpdated')
        this.$zoneUpdated = this.find('.zoneUpdated')
        this.$zoneUpdatedText = this.find('.zoneUpdated .text')
        this.$errorMessage = this.find('.errorMessage')
        this.$contextInput = this.find('.url .context .contextInput')
        this.$tickIcon = this.find('.process .tickIcon')
        this.$spinnerIcon = this.find('.process .spinnerPlaceholder')

        this.contextInput = new InputField({
            onChange: this.callbacks.onContextChanged,
            maxLength: 25,
        }).init(this.$contextInput)

        const tooltip = new SimpleTooltip({
            text: messageResource.getMessage('licenses.purchase_lightbox.review_context.tooltip'),
            extraClass: 'contextInfoTooltip',
        }).init($('body'))
        tooltip.subscribeToMouseEvents(this.find('.url .context .infoIcon'))

        this.checkingSpinner = new LoadingSpinner().init(this.$spinnerIcon)
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/accountInfo/ContextEditor.js